/**
 * Canonical environment values.
 * Mirrors server/src/models/Environment.ts — keep in sync.
 */
const Environment = Object.freeze({
  DEV: "development",
  TEST: "test",
  PROD: "production",
});

export default Environment;
